export const SP500_FUND_INDEX_ID = 1022
